import React from "react";
import { colorFor } from "../lib/constants";

// Circular SVG score meter out of 60
export function ScoreMeter({ score, max = 60, colorKey = "success", size = 220, label }) {
  const stroke = 16;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(1, score / max));
  const dash = c * pct;
  const color = colorFor(colorKey);

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}
      role="img" aria-label={`Financial health score ${score} out of ${max}`}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#E2E8F0" strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
          strokeLinecap="round" strokeDasharray={`${dash} ${c}`}
          style={{ transition: "stroke-dasharray 1s ease-out" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <div className="font-heading font-extrabold text-navy leading-none" style={{ fontSize: size * 0.28 }}>
          {score}
        </div>
        <div className="text-slate-400 font-heading font-semibold" style={{ fontSize: size * 0.09 }}>
          / {max}
        </div>
        {label && <div className="mt-1 text-xs font-semibold" style={{ color }}>{label}</div>}
      </div>
    </div>
  );
}
